import React from 'react';

/**
 * Report Banner Component
 * Header banner for reports with student info
 */
const ReportBanner = ({ 
  studentName, 
  school, 
  grade, 
  section, 
  reportType,
  icon = '📊',
  color = 'primary'
}) => {
  const gradients = {
    primary: 'from-primary-600 to-primary-700',
    secondary: 'from-secondary-600 to-secondary-700',
    green: 'from-green-600 to-green-700',
    blue: 'from-blue-600 to-blue-700',
    purple: 'from-purple-600 to-purple-700'
  };

  const gradient = gradients[color] || gradients.primary;

  return (
    <div className={`bg-gradient-to-r ${gradient} rounded-xl p-4 sm:p-8 mb-8 shadow-2xl`}>
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6">
        <div className="flex items-center gap-4 sm:gap-6 flex-1">
          <div className="text-5xl sm:text-7xl">{icon}</div>
          <div className="flex-1">
            <h1 className="text-2xl sm:text-3xl font-bold text-white mb-2">
              {reportType}
            </h1>
            <div className="text-white/90 space-y-1">
              <p className="text-lg sm:text-xl font-semibold">{studentName}</p>
              <p className="text-xs sm:text-sm">{school}</p>
              <p className="text-xs sm:text-sm">Grade {grade} - Section {section}</p>
            </div>
          </div>
        </div>
        
        <div className="text-left sm:text-right text-white/80 w-full sm:w-auto">
          <p className="text-xs sm:text-sm">Generated on</p>
          <p className="text-base sm:text-lg font-semibold">
            {new Date().toLocaleDateString('en-IN', { 
              day: 'numeric', 
              month: 'long', 
              year: 'numeric' 
            })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReportBanner;
